module.exports = __webpack_public_path__ + "static/media/GabrielleHempel.1177887e.jpg";